import store from "@/store";

const generateDataLayerValue = async (type, options, eventtype) => {
  const sess = await store.getters["userSession/GET_SESSION"];
  switch (type) {
    case "getCarCategorySwitchSelect": {
      const GET_CARTYPE = await store.getters["userSession/GET_CAR_SELECTED"];

      // console.log(GET_CARTYPE);
      return GET_CARTYPE || "";
    }
    case "getCarCategory": {
      const GET_CARGROUP = await store.getters["userSession/GET_CARGROUP"];

      const GET_CARGROUP_BY_ID = await store.getters[
        "cargroup/GET_CARGROUP_BY_ID"
      ](GET_CARGROUP);

      if (!GET_CARGROUP) return "";

      if (options.car) {
        return options.car.category || "";
      }

      return GET_CARGROUP_BY_ID.vehicle_category[0].id;
    }
    case "getCarGroup": {
      const GET_CARGROUP = await store.getters["userSession/GET_CARGROUP"];
      if (!GET_CARGROUP) return "";
      const GET_CARGROUP_BY_ID = await store.getters[
        "cargroup/GET_CARGROUP_BY_ID"
      ](GET_CARGROUP);
      if (options.car) {
        return options.car.id || "";
      }
      return GET_CARGROUP_BY_ID.text_web;
    }
    case "getVehicleId": {
      return "getVehicleId";
    }
    case "getStationStart": {
      return sess.selectedStation || "";
    }
    case "getStationEnd": {
      return sess.selectedStationEnd || sess.selectedStation;
    }
    case "getReservationDuration": {
      const date_1 = new Date(sess.reservationDate.start);
      const date_2 = new Date(sess.reservationDate.end);

      const days = (date_1, date_2) => {
        const difference = date_1.getTime() - date_2.getTime();
        const TotalDays = -Math.ceil(difference / (1000 * 3600 * 24));
        return TotalDays + 1;
      };
      return days(date_1, date_2);
    }
    case "getTimeStamp": {
      return new Date().getTime();
    }
    case "getScreenSize": {
      return window.screen.width + "x" + window.screen.height;
    }
    case "getTotalPrice": {
      // const succ = await store.getters["reservation/GET_RESERVATION_SUCCESS"];
      // console.log(succ);
      if (await store.getters["reservation/GET_RESERVATION"]) {
        const GET_RESERVATION = await store.getters[
          "reservation/GET_RESERVATION"
        ];
        return GET_RESERVATION.end_positions[2].total_long_price;
      } else if (await store.getters["reservation/GET_RESERVATION_SUCCESS"]) {
        const GET_RESERVATION = await store.getters[
          "reservation/GET_RESERVATION_SUCCESS"
        ];
        return GET_RESERVATION.invoice_positions.endPositions[2]
          .total_long_price;
      } else {
        return false;
      }
    }
    case "getSelectValue": {
      return options;
    }
    case "getOptions": {
      return options;
    }
    case "getDealerName": {
      const station = await store.getters["stations/GET_STATIONS_FILTERED"];
      // console.log(station);
      if (Object.keys(station).length == 0) return "";
      const selected = station["ALL"].find(
        (station) => station.id === sess.selectedStation
      );

      return selected.name;
    }
    case "getDealerNameCTA": {
      const station = await store.getters["stations/GET_STATIONS_FILTERED"];
      if (Object.keys(station).length == 0) return "";
      const selected = station["ALL"].find(
        (station) => station.id === sess.selectedStation
      );

      return eventtype + " - " + selected.name;
    }
    case "getDealerAddress": {
      const station = await store.getters["stations/GET_STATIONS_FILTERED"];
      if (Object.keys(station).length == 0) return "";
      const selected = station["ALL"].find(
        (station) => station.id === sess.selectedStation
      );

      return selected.street;
    }
    case "getDealerZip": {
      const station = await store.getters["stations/GET_STATIONS_FILTERED"];
      if (Object.keys(station).length == 0) return "";
      const selected = station["ALL"].find(
        (station) => station.id === sess.selectedStation
      );

      return selected.zipcode;
    }
    case "getDealerId": {
      return "getDealerId";
    }
    case "getLeadId": {
      return "getLeadId";
    }
    case "getTicked": {
      if (options) {
        return "checkbox ticked";
      } else {
        return "checkbox unticked";
      }
    }
    case "getDestination": {
      return options.destination;
    }
    case "getExtraPrice": {
      return options.extra.total_long_price;
    }
    case "getExtraLabel": {
      return options.extra.description;
    }
    case "getAddRemove": {
      return options.amount == 0 ? "remove" : "add";
    }
    default:
      return type;
  }
};

// const generateDataLayer = async (eventtype, options) => {
//   const config = JSON.parse(process.env.VUE_APP_ANALYTICS_CONFIG);
//   const event = config.orm[eventtype] || {};
//   const attributes = JSON.parse(JSON.stringify(event));

//   for (const type in event) {
//     switch (typeof event[type]) {
//       case "object":
//         for (const key in event[type]) {
//           attributes[type][key] = await generateDataLayerValue(
//             event[type][key],
//             options
//           );
//         }
//         break;
//       case "array":
//         for (const key in event[type]) {
//           attributes[type][key] = await generateDataLayerValue(
//             event[type][key],
//             options
//           );
//         }
//         break;
//       case "string":
//         attributes[type] = await generateDataLayerValue(event[type], options);
//         break;
//       default:
//         break;
//     }
//   }

//   return attributes;
// };

const generateAnalytics = async (eventtype, options, module) => {
  const config = JSON.parse(process.env.VUE_APP_ANALYTICS_GOOGLE_CONFIG);
  if (module) console.log(module);
  // console.log("google", config);

  const layerVar = "googleDataLayer"; // googleDataLayer

  // const date = new Date().getTime();
  if (eventtype === "pageLoad") {
    window[layerVar] = window[layerVar] || [];

    const event = config.orm[eventtype];
    // console.log(eventtype);
    // console.log(event);

    const opts = { event: "event_pageview" };

    for (const key in event) {
      opts[key] = await generateDataLayerValue(event[key], options);
    }

    // console.log(opts);

    window[layerVar].push(opts);
    return false;
  } else {
    const opts = { event: eventtype };
    const event = config.orm[eventtype];
    if (!event) return;
    for (const key in event) {
      opts[key] = await generateDataLayerValue(event[key], options, eventtype);
    }

    // console.log(opts);
    window[layerVar].push(opts);
  }
  // const attributes = generateDataLayer(eventtype, options);

  // window.dataLayer = window.dataLayer || [];
  // window.dataLayer.push({
  //   event: "orm_click",
  //   module,
  //   timestamp: date,
  //   type: eventtype,
  //   attributes,
  // });
};

const generateAdobe = async (eventtype, options, moduleName) => {
  // console.log("adobe", eventtype, options, moduleName);
  const config = JSON.parse(process.env.VUE_APP_ANALYTICS_CONFIG);
  // console.log(config);
  if (eventtype === "pageLoad") {
    eventtype = eventtype + "_" + options.pageType;
  }

  if (moduleName) {
    eventtype = eventtype + "_" + moduleName;
  }

  if (eventtype === "headerStep_jump" + "_" + moduleName) {
    eventtype = eventtype + "_" + options.to;
  }

  if (eventtype === "reservation_change" + "_" + moduleName) {
    eventtype = eventtype + "_" + options.to;
  }

  window.dataLayer = [];
  const event = config.orm[eventtype];
  if (!event) return;
  for (const key in event) {
    if (key !== "_satellite") {
      window.dataLayer[key] = await generateDataLayerValue(event[key], options);
    }
  }

  window._satellite.track(event["_satellite"]);
};

const buildDataLayer = async (eventtype, options, moduleName) => {
  // console.log("buildDataLayer", eventtype, options, moduleName);
  if (process.env.VUE_APP_ANALYTICS_DATALAYER === "true") {
    if (process.env.VUE_APP_ANALYTICS_ADOBE === "true") {
      await generateAdobe(eventtype, options, moduleName);
    }
    await generateAnalytics(eventtype, options, moduleName);
  } else {
    return false;
  }
};

export { buildDataLayer };
